module.exports = __webpack_public_path__ + "img/footer_logo.35e83783.svg";